import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden pt-16 lg:pt-0">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/fe81f318e72015be781a7ea95136e716.jpg"
            alt="VyŽehlené - Profesionální žehlení"
            className={`w-full h-full object-cover transition-all duration-1000 ${
              isLoaded ? 'scale-100 opacity-100' : 'scale-110 opacity-0'
            }`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
          <div className="mb-6">
            <h1
              className={`text-5xl sm:text-7xl md:text-9xl font-bold text-white mb-2 leading-tight transition-all duration-1000 ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-10'
              }`}
            >
              {t('hero.badge')}
            </h1>
            <p
              className={`text-2xl sm:text-3xl md:text-4xl text-white font-semibold mb-4 transition-all duration-1000 delay-200 whitespace-pre-line ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('hero.title')}
            </p>
            <p
              className={`text-xl sm:text-2xl text-white/90 mb-6 max-w-3xl mx-auto transition-all duration-1000 delay-300 whitespace-pre-line ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              {t('hero.subtitle')}
            </p>
          </div>

          {/* Scroll indicator */}
          <div
            className={`absolute bottom-10 left-1/2 transform -translate-x-1/2 transition-all duration-1000 delay-700 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="animate-bounce">
              <i className="ri-arrow-down-line text-3xl text-white/70"></i>
            </div>
          </div>
        </div>
      </section>

      {/* Ruční práce má hodnotu section */}
      <div className="relative mt-24 py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20woman%20carefully%20hand%20ironing%20white%20cotton%20shirt%20on%20wooden%20ironing%20board%20in%20bright%20natural%20light%20home%20interior%20warm%20atmosphere%20focused%20concentration%20gentle%20hands%20working%20with%20steam%20iron%20close%20up%20view%20of%20quality%20garment%20care%20artisan%20craftsmanship%20peaceful%20domestic%20scene%20soft%20beige%20cream%20background%20authentic%20handwork%20premium%20fabric%20treatment%20careful%20attention%20to%20detail&width=1920&height=1080&seq=hand-ironing-work-value-001&orientation=landscape"
            alt="Ruční žehlení s péčí"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold mb-8 text-white drop-shadow-2xl">
            Ruční práce má hodnotu
          </h2>
          <div className="text-2xl text-white space-y-6 leading-relaxed drop-shadow-2xl">
            <p>
              Ve Vyžehlené věříme, že některé věci se mají dělat pomalu.
            </p>
            
            <p>
              Proto spolupracujeme s lidmi, pro které je ruční práce přirozená.<br />
              S rodiči na rodičovské, aktivními seniory nebo lidmi se zdravotním omezením.
            </p>
            
            <p>
              Ne proto, že by to bylo levnější.
            </p>
            
            <p className="font-semibold">
              Ale proto, že je to lepší.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
